/**
 * https://blog.csdn.net/weixin_34007879/article/details/91398659
 * 预渲染插件使用
 */
export var isPrerender = window.__PRERENDER_INJECTED__ === 'prerender';

if (process.env.VUE_APP_RUNTIME_ENV === 'production') {
  /**
   * 重点部分：项目中的路径要控制一下，预渲染的时候用相对路径
   */
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = isPrerender ? '' : 'https://cdn-static.kwai.net/kos/s101/nlav11312/creator/'; // eslint-disable-next-line no-undef
}